export interface CookieData {
	favorites?: string;
	preferences?: string;
	'nuxt-session'?: string;
	'last-viewed-property'?: string;
}

/**
 * Composable helper para coletar dados dos cookies
 * para uso com nuxtPropertiesRepository
 */
export function useCookieData(): () => CookieData {
	const { cookie: favoritesCookie } = useFavoritesCookie();
	const { getPreferences } = usePreferencesCookie();
	const sessionCookie = useCookie<string>('nuxt-session');
	const lastViewedPropertyCookie = useCookie<string>('last-viewed-property');

	return () => {
		const cookieData: CookieData = {};

		if (favoritesCookie.value) {
			cookieData.favorites = favoritesCookie.value;
		}

		const preferences = getPreferences();
		if (preferences && Object.keys(preferences).length > 0) {
			cookieData.preferences = JSON.stringify(preferences);
		}

		if (sessionCookie.value) {
			cookieData['nuxt-session'] = sessionCookie.value;
		}

		if (lastViewedPropertyCookie.value) {
			cookieData['last-viewed-property'] = lastViewedPropertyCookie.value;
		}

		return cookieData;
	};
}
